import React, { useState } from "react";
import { useAddNewsletterMutation } from "../../../service/notificationsAPI";

const Newslettersub = () => {
  const [subscripe, { isLoading }] = useAddNewsletterMutation();
  const [email, setEmail] = useState<string>("");
  const [isValid, setIsValid] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  function handleSendSub(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    subscripe({ email, subscriptionDate: new Date().toISOString() })
      .unwrap()
      .then((data) => {
        setSuccess(true);
      })
      .catch((e) => {
        if (e.data?.responseCode === 400) {
          setError(e.data?.message);
        }
        setIsError(true);
      })
      .finally(() => {
        setTimeout(() => {
          setIsError(false);
          setError("");
          setSuccess(false);
          setEmail("");
        }, 3000);
      });
  }

  return (
    <form className="relative" onSubmit={handleSendSub}>
      <div className="font-normal text-gray-900 mb-3 font-['Poppins'] text-base leading-7">Newsletter</div>
      <div className="flex items-center bg-gray-50 border border-gray-200 rounded-[12px] pl-4 pr-1 py-1">
        <input
          type="email"
          value={email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setIsValid(e.target.checkValidity());
            setEmail(e.target.value);
          }}
          className="flex-1 w-32 sm:w-40 text-sm text-gray-600 bg-transparent focus:outline-none placeholder-gray-400"
          placeholder="Enter your email"
          required
          pattern="^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$"
        />
        <button
          className="px-5 py-2 text-sm font-medium bg-white text-primary border border-primary rounded-[10px] hover:bg-primary hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          type="submit"
          disabled={!isValid || isLoading}
        >
          {isLoading ? "..." : "Subscribe"}
        </button>
      </div>
      {success && (
        <span className="text-xs text-green-600 mt-2 block">
          Subscribed to the newsletter successfully!
        </span>
      )}
      {isError && (
        <span className="text-xs text-red-500 mt-2 block">
          {error ? error : "Failed, please try again"}
        </span>
      )}
    </form>
  );
};

export default Newslettersub;
